import { PassThrough } from "stream";

export function useValidation() {
  const required = (value: string | number) =>
    (value !== null && value !== undefined && value !== "") || "Required.";

  const inSet = (set: string[]) => (value: string[]) => {
    console.log("value", value, "set", set);

    return value.every((v) => set.includes(v)) || "Invalid value.";
  };

  const email = (value: string) => {
    if (!value) {
      return true;
    }
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || "Invalid e-mail.";
  };

  // check for valid phone number
  // allows for some international numbers, extensions, and various formats
  const phoneNumber = (value: string) => {
    if (!value) {
      return true;
    }
    const pattern =
      /^(((\+\d{1,2})?[\s-.]?((\(\d{3}\))|(\d{3}))[\s.-]?\d{3}[\s.-]?\d{4}(?:((\s*x)|(\s))+([\s0-9a-z]+))?\s?)|)$/;
    return pattern.test(value) || "Invalid phone number.";
  };

  const parseDate = (value?: string | Date) => {
    if (!value) return null;
    if (typeof value == "string") {
      const [month, day, year] = value.split("/").map(Number);
      const date = new Date(year, month - 1, day);
      const isValidDate =
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;
      if (isValidDate) return date;
      return null;
    }
    return value as Date;
  };

  const date = (value?: string | Date) => {
    if (!value) {
      return true;
    }
    const date = parseDate(value);
    return !!date || "Invalid date.";
  };

  const birthdate = (value?: string | Date) => {
    if (!value) {
      return true;
    }
    const date = parseDate(value);
    if (!date) return "Invalid date.";
    // check if date in the past
    const now = new Date();
    const isPast = date < now;
    // check if date is less than 200 years ago
    const isLessThan200YearsAgo = now.getFullYear() - date.getFullYear() < 200;
    return (isPast && isLessThan200YearsAgo) || "Invalid birthdate.";
  };

  const digits = (input: string) => {
    // ^\d+$ means "start of string, one or more digits, end of string"
    return /^\d+$/.test(input) || "Numbers only.";
  };

  const digitsOrNull = (input: string) => {
    // ^\d+$ means "start of string, one or more digits, end of string"
    return (
      input === null || input === "" || /^\d+$/.test(input) || "Numbers only."
    );
  };

  const maxLength = (max: number) => (value: number | string) =>
    String(value).length <= max || `Exceeds maximum length of ${max}.`;

  return {
    required,
    inSet,
    email,
    phoneNumber,
    date,
    birthdate,
    digits,
    digitsOrNull,
    maxLength,
  };
}
